import { Encoding } from "../settings/types";

const GSM7_EXTENDED = new Set(["^", "{", "}", "\\", "[", "]", "~", "|", "€"]);

export interface SegmentInfo {
  length: number; // characters used (GSM-7 counts extended chars as 2)
  segments: number; // number of SMS parts
  perSegment: number; // capacity of the current segmentation
  remaining: number; // characters left before another segment is needed
}

function gsm7Length(text: string): number {
  let length = 0;
  for (const ch of text) {
    length += GSM7_EXTENDED.has(ch) ? 2 : 1;
  }
  return length;
}

export function computeSegments(text: string, encoding: Encoding): SegmentInfo {
  const single = encoding === "unicode" ? 70 : 160;
  const multi = encoding === "unicode" ? 67 : 153;
  const length = encoding === "unicode" ? [...text].length : gsm7Length(text);

  const segments = length <= single ? 1 : Math.ceil(length / multi);
  const capacity = segments === 1 ? single : segments * multi;

  return {
    length,
    segments,
    perSegment: segments === 1 ? single : multi,
    remaining: capacity - length,
  };
}
